<template>
  <div class="view">
    <div class="title">
      <i class="goback el-icon-arrow-left" @click="goback"></i>编辑员工信息
    </div>
    <div class="content">
      <div class="set_wrap">
        <el-form ref="form" :rules="rules" :model="formdata" label-width="220px">
          <el-form-item label="头像" prop="pic">
            <!--<el-upload-->
                    <!--class="avatar-uploader"-->
                    <!--:action="uploadImg"-->
                    <!--:data="data_"-->
                    <!--:file-list="fileList"-->
                    <!--:show-file-list="false"-->
                    <!--:on-success="handleAvatarSuccess"-->
                    <!--:before-upload="beforeAvatarUpload"-->
            <!--&gt;-->
              <!--<img v-if="formdata.pic" :src="formdata.pic" class="avatar"/>-->
              <!--<i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
            <!--</el-upload>-->
            <uploadImg @getChildValue="getChildValue" imgNumber="1" page="employeeEdit"
                       :picSrc="formdata.pic"></uploadImg>
          </el-form-item>
          <el-form-item label="工号">
            <el-input type="text" v-model="formdata.work_number" placeholder="请输入工号" class="w340"></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input type="text" v-model="formdata.name" placeholder="请输入姓名" class="w340" maxlength="4" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="职位" prop="position">
            <el-input type="text" v-model="formdata.position" placeholder="请输入职位" class="w340"></el-input>
          </el-form-item>
          <el-form-item label="名片展示手机号" prop="phone">
            <el-input type="text" v-model="formdata.phone" placeholder="请输入名片展示手机号" class="w340"></el-input>
            <p class="infodescribe">*国际手机号,请在手机号前添加“+地区代码”，如 +8613800123456</p>
            <p class="infodescribe">此号将显示在AI名片的联系方式上，可在AI雷达“我”-“个人信息”中修改。</p>
          </el-form-item>
          <el-form-item label="是否内部人员">
            <el-switch
              v-model="formdata.is_out"
              active-color="#2AA3F8"
              inactive-color="#ff4949">
            </el-switch>
          </el-form-item>
          <el-form-item label="部门">
            <div class="partmentList">
              <!--<p class="choosedep" v-for="item in partmentList">{{formdata.department}}</p>-->
              <p class="choosedep" v-for="(item,index) in partmentListName" :key="index">{{item}} <i class="el-icon-circle-close"
                                                                                        @click="closePartmentFn(index)"></i>
              </p>
            </div>
            <el-button @click="choosedep">选择部门</el-button>
          </el-form-item>
          <el-form-item label="企管角色">
            <div v-if="is_edit==1">
              <el-select v-model="formdata.role_id" placeholder="请选择" @change="changeEmployee">
                <el-option
                        v-for="item in tagList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div v-else>{{role_name?role_name:'-'}}</div>
          </el-form-item>
          <div style="background:#eee;padding:10px 0;" v-if="formdata.role_id">
            <el-form-item label="登录账号">
              <el-input type="text" v-model="formdata.account" placeholder="请输入登录账号" class="w340"
                        autocomplete="new-password" :disabled="is_edit==1?false:true"></el-input>
            </el-form-item>
            <el-form-item label="登录密码">
              <el-input type="password" v-model="formdata.password" placeholder="请输入登录密码" class="w340"
                        autocomplete="new-password" :disabled="is_edit==1?false:true"></el-input>
              <p>添加时必填，编辑时可为空，默认为上次保存的信息</p>
            </el-form-item>
          </div>
          <el-form-item label="绑定登录手机号">
            {{formdata.we_phone}}
            <p class="infodescribe">此号将作为APP登录账号，用于登录和接收AI雷达消息，一旦绑定不可修改！</p>
            <div class="height50"></div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="save('form')">保存</el-button>
            <el-button @click="goback">返回</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <chooseDepDialog
            :visible.sync="choosedepdialog"
            v-if="choosedepdialog"
            @choosedepsucess="choosedepsucess"
    ></chooseDepDialog>
  </div>
</template>
<script>
  import api from "@/api.js";
  import chooseDepDialog from "@/components/dialog/chooseDepDialog.vue";
  import uploadImg from "@/components/dialog/uploadImg.vue";

  export default {
    name: "employeeEdit",
    components: {
      chooseDepDialog,
      uploadImg
    },
    data() {
      return {
        uploadImg: api.uploadTokenImg,
        data_: {token: sessionStorage.getItem("token")},
        formdata: {
          em_id: "",
          work_number: "",
          pic: "",
          name: "",
          position: "",
          depart_id: "",
          department: "",
          phone: "",
          we_phone: "",
          role_id: "",
          account: "",
          password: "",
          is_set: "",
          is_out:""
        },
        imageUrl: "",
        lock: true,
        choosedepdialog: false,
        // fileList: [],
        partmentListName: [],
        partmentListId: [],
        rules: {
          pic: [{required: true, message: "请选择员工头像", trigger: "blur"}],
          name: [{required: true, message: "请输入姓名", trigger: "blur"}],
          position: [{required: true, message: "请输入职位", trigger: "blur"}],
          phone: [
            {required: true, message: "请输入绑定登录手机号", trigger: "blur"}
          ]
        },
        tagList: [
          {
            label: '无',
            value: 0
          }
        ],
        is_edit: null,
        role_name: ""
      };
    },
    created() {
      this.queryemployeedetail();
    },
    methods: {
      // 查询员工详情
      queryemployeedetail() {
        // is_edit	1可修改 部门 企业角色
        this.axios
            .post(api.employee_detail, {em_id: this.$route.query.employeeid})
            .then(response => {
              if (response.data.code == 0) {
                for (let i in this.formdata) {
                  if (i === "role_id" && !response.data.info[i]) {
                    this.formdata.role_id = "";
                  } else {
                    this.formdata[i] = response.data.info[i];
                  }
                  if(i == 'is_out'){
                    this.formdata[i] = response.data.info[i]?true:false;
                  }
                }
                ;
                // "is_edit":"是否可以修改角色(0不可修改、1可以修改)",
                this.is_edit = response.data.info.is_edit;
                // this.fileList = [{name: "user", url: response.data.info.pic}];
                this.role_name = response.data.info.role;
                this.is_edit = response.data.info.is_edit;
                for (let i in response.data.info.department) {
                  this.partmentListName.push(response.data.info.department[i].name);
                  this.partmentListId.push(response.data.info.department[i].id);
                }
                ;
                this.role_index();
              } else {
              }
            })
            .catch(response => {
            });
      },
      role_index() {
        this.axios
            .post(api.role_index, {page: 1})
            .then(response => {
              if (response.data.code == 0) {
                for (let i in response.data.list) {
                  if (Number(i) !== 0) {
                    let list = {};
                    list.label = response.data.list[i].name;
                    list.value = response.data.list[i].id;
                    this.tagList.push(list);
                    // if (Number(this.formdata.role_id) === Number(response.data.list[i].id)) {
                    //   this.role_name = response.data.list[i].name
                    // }
                  }
                }
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 选择部门
      choosedep() {
        this.choosedepdialog = true;
      },
      choosedepsucess(val) {
        // partmentListName:[],
        // partmentListId:[],
        // this.formdata.department = val.name;
        // this.formdata.depart_id = val.id;
        if (this.partmentListId.indexOf(val.id) !== -1) {
          this.$message.error('部门已经存在');
          return
        }
        this.partmentListName.push(val.name);
        this.partmentListId.push(val.id);
      },
      // 保存
      save(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.lock) {
              this.lock = false;
              this.submitsave();
            }
          } else {
            return false;
          }
        });
      },
      // 提交保存
      submitsave() {
        if (this.partmentListId.length === 0) {
          this.$message.error('请选择相应部门');
          return
        }
        if (this.formdata.role_id) {
          if (!this.formdata.account) {
            this.$message.error('请填写角色登入账号');
            return
          }
        }else{
          this.formdata.is_set = 0
          this.formdata.account = null
        }
        this.formdata.depart_id = this.partmentListId.join(',');
        this.formdata.em_id = this.$route.query.employeeid;
        this.formdata.is_out = this.formdata.is_out?1:0
        this.axios
            .post(api.employee_edit, this.formdata)
            .then(response => {
              this.lock = true;
              if (response.data.code == 0) {
                this.$message({
                  message: "员工编辑成功",
                  type: "success"
                });
              } 
            })
            .catch(response => {
              this.lock = true;
            });
      },
      handleAvatarSuccess(res, file) {
        if (res.code === 0) {
          this.formdata.pic = res.path;
        } else {
          this.$message.error(res.msg);
        }
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
          this.$message.error("上传头像图片大小不能超过 10MB!");
        }
        return isLt2M;
      },
      goback() {
        this.$router.go(-1);
      },
      closePartmentFn(index) {
        this.partmentListName.splice(index, 1);
        this.partmentListId.splice(index, 1);
      },
      changeEmployee(val){
        if(!val){
        }
      },
      getChildValue(option) {
        this.formdata.pic = option
      }
    }
  };
</script>
